export default __webpack_public_path__ + "static/media/cvc.721e1222.svg";